import type { NamedArgs, PositionalArgs } from "ember-modifier";
import "../vendor/accordion.min.js";
import FuiModuleModifier, { type Signature } from "./fui-module";

export default class FuiAccordionModifier extends FuiModuleModifier {
  override semanticModuleName = "accordion";

  override modify(
    element: Signature["Element"],
    positional: PositionalArgs<Signature>,
    named: NamedArgs<Signature>
  ): void {
    super.modify(element, positional, named);

    if (named["active"]) {
      this.openAccordion();
    }
  }

  openAccordion(): void {
    this.semanticModule("open", 0); // Open the first accordion item
  }
}
